export default __webpack_public_path__ + "static/media/login-bg.0f2b15e2.png";